<ng-container *transloco="let t">
	<nav class="mobile-tab-bar" aria-label="Navigation">
		<ion-button class="mobile-tab" fill="clear"
		            [routerLink]="translateService.localize('/app/search')"
		            routerLinkActive="active"
		            [attr.aria-label]="t('page.label.search')">
			<ion-icon name="search-outline" aria-hidden="true"></ion-icon>
			<ion-label>{{ t('page.label.search') }}</ion-label>
		</ion-button>
		<ion-button class="mobile-tab" fill="clear"
		            [routerLink]="translateService.localize('/app/messages')"
		            routerLinkActive="active"
		            [attr.aria-label]="t('page.label.message')">
			<ion-icon name="chatbubble-ellipses-outline" aria-hidden="true"></ion-icon>
			<ion-label>{{ t('page.label.message') }}</ion-label>
			@if (privateMessageNotification() > 0) {
				<ion-badge class="tab-badge" aria-hidden="true">{{ privateMessageNotification() }}</ion-badge>
			}
		</ion-button>
		<ion-button class="mobile-tab" fill="clear"
		            [routerLink]="translateService.localize('/app/contacts')"
		            routerLinkActive="active"
		            [attr.aria-label]="t('page.label.contacts')">
			<ion-icon name="people-outline" aria-hidden="true"></ion-icon>
			<ion-label>{{ t('page.label.contacts') }}</ion-label>
			@if (contactNotification() > 0) {
				<ion-badge class="tab-badge" aria-hidden="true">{{ contactNotification() }}</ion-badge>
			}
		</ion-button>
		<ion-button class="mobile-tab" fill="clear"
		            [routerLink]="translateService.localize('/app/profile')"
		            routerLinkActive="active"
		            [attr.aria-label]="t('page.label.profile')">
			<ion-icon name="person-outline" aria-hidden="true"></ion-icon>
			<ion-label>{{ t('page.label.profile') }}</ion-label>
		</ion-button>
		<ion-button class="mobile-tab" fill="clear"
		            [routerLink]="translateService.localize('/app/settings')"
		            routerLinkActive="active"
		            [attr.aria-label]="t('page.label.settings')">
			<ion-icon name="settings-outline" aria-hidden="true"></ion-icon>
			<ion-label>{{ t('page.label.settings') }}</ion-label>
		</ion-button>
	</nav>
</ng-container>
